// extracted by mini-css-extract-plugin
export default {"download":"DownloadButton_download","downloadPending":"DownloadButton_downloadPending DownloadButton_download","downloadIcon":"DownloadButton_downloadIcon"};